import { useMutation } from 'react-query';

import { setHomePage as mutationFn } from 'api/endPoints/setHomePage';

const useMutationSetHomePage = () => {
    return useMutation<unknown, QueryError, { urlPage: string }>((params: { urlPage: string }) => mutationFn(params));
};

export { useMutationSetHomePage };
